export const DsfMonacoCustom=Vue.defineLazyComponent(()=>require('./monacoEditorCustom.vue'));